export enum PAGE_NAME {
  LANDING = '0',
  REGISTER = '1',
}

export enum ACTION_TYPE {
  OPEN_APP = '2',
  OPEN_REGISTER_PAGE = '3',
  OPEN_URL = '4',
}
